var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_lock",
    "data-name": "vuesax/outline/lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.031,6.729A.535.535,0,0,1,8.5,6.2V4.781c0-2.231-.63-3.719-3.719-3.719S1.062,2.55,1.062,4.781V6.2a.535.535,0,0,1-.531.531A.535.535,0,0,1,0,6.2V4.781C0,2.727.5,0,4.781,0S9.562,2.727,9.562,4.781V6.2A.535.535,0,0,1,9.031,6.729Z",
    transform: "translate(3.719 0.885)",
    fill: "#96a0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.156,9.563H4.073C.949,9.563,0,8.613,0,5.49V4.073C0,.949.949,0,4.073,0h7.083c3.124,0,4.073.949,4.073,4.073V5.49C15.229,8.613,14.28,9.563,11.156,9.563Zm-7.083-8.5c-2.536,0-3.01.482-3.01,3.01V5.49c0,2.529.475,3.01,3.01,3.01h7.083c2.536,0,3.01-.482,3.01-3.01V4.073c0-2.529-.475-3.01-3.01-3.01Z",
    transform: "translate(0.885 6.552)",
    fill: "#96a0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M.708,1.416a.705.705,0,0,1-.269-.057A.731.731,0,0,1,.205,1.21.732.732,0,0,1,0,.708.705.705,0,0,1,.057.438.731.731,0,0,1,.205.2.731.731,0,0,1,.439.056.71.71,0,0,1,1.211.2.818.818,0,0,1,1.36.438a.705.705,0,0,1,.057.269.745.745,0,0,1-.205.5A.745.745,0,0,1,.708,1.416Z",
    transform: "translate(4.958 10.626)",
    fill: "#96a0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.708,1.417a.745.745,0,0,1-.5-.205A.732.732,0,0,1,0,.709.594.594,0,0,1,.057.44.818.818,0,0,1,.205.206.707.707,0,0,1,.843.015.427.427,0,0,1,.978.057.536.536,0,0,1,1.1.121a1.116,1.116,0,0,1,.106.085A.818.818,0,0,1,1.36.44a.705.705,0,0,1,.057.269.732.732,0,0,1-.205.5L1.1,1.3a.536.536,0,0,1-.127.064A.427.427,0,0,1,.843,1.4.868.868,0,0,1,.708,1.417Z",
    transform: "translate(7.792 10.624)",
    fill: "#96a0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.708,1.417a.732.732,0,0,1-.5-.205A.818.818,0,0,1,.057.978.705.705,0,0,1,0,.709a.745.745,0,0,1,.205-.5L.312.121A.536.536,0,0,1,.439.057.45.45,0,0,1,.567.015a.721.721,0,0,1,.645.191.732.732,0,0,1,.205.5A.705.705,0,0,1,1.36.978a.731.731,0,0,1-.149.234A.745.745,0,0,1,.708,1.417Z",
    transform: "translate(10.625 10.624)",
    fill: "#96a0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H17V17H0Z",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8fb83cb04959f9269b81e93515a5ce54.svg";
export { ForwardRef as ReactComponent };